import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const Floor = ({ value }) => {
  const { t } = useTranslation()
  if (value == null) return null
  return <Typography>{t('floor {{n}}', { n: value })}</Typography>
}
